var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "position-relative w-100" },
    [
      _c("b-form-input", {
        ref: "input_ref",
        attrs: {
          readonly: "",
          disabled: _vm.isDisabled,
          state: _vm.state,
          value: _vm.selectedValue,
          placeholder: _vm.placeholder
        },
        on: {
          focus: _vm.onFocusIn,
          blur: _vm.onFocusOut,
          click: function($event) {
            _vm.isFocus = true
          }
        }
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "custom-btn-select",
          attrs: { type: "button", disabled: _vm.isDisabled },
          on: {
            mousedown: function($event) {
              $event.preventDefault()
              return _vm.onClick.apply(null, arguments)
            }
          }
        },
        [
          _vm.value !== null && _vm.value !== ""
            ? _c("v-icon", { attrs: { name: "buttons/cross", size: 11 } })
            : _vm.isFocus
            ? _c("v-icon", {
                attrs: { name: "buttons/collapse_chevrons_down", size: 10 }
              })
            : _c("v-icon", {
                attrs: { name: "buttons/collapse_chevrons_right", size: 10 }
              })
        ],
        1
      ),
      _vm._v(" "),
      _vm.isFocus
        ? _c(
            "div",
            {
              staticClass: "custom-dropdown-select",
              class: { "drop-up": _vm.dropUp }
            },
            [
              _c(
                "div",
                { staticClass: "custom-dropdown-list-scroll" },
                _vm._l(_vm.options, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "custom-dropdown-select-item",
                      class: { active: item.value === _vm.value },
                      on: {
                        mousedown: function($event) {
                          $event.preventDefault()
                          return _vm.onSelect(item)
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "text-small" }, [
                        _vm._v(_vm._s(item.text))
                      ])
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm.options.length === 0
                ? _c(
                    "div",
                    { staticClass: "empty-state-container p-2" },
                    [
                      _c("v-icon", {
                        attrs: { name: "navbar/empty_table", size: 45 }
                      }),
                      _vm._v(" "),
                      _c("small", { staticClass: "text-muted" }, [
                        _vm._v("Ничего не найдено")
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-06003962", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06003962","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/utilites/commonUi/BaseSelect.vue
// module id = null
// module chunks = 